import React from 'react';
import Sidebar from './Sidebar';
export var MobileHeader = function MobileHeader(_ref) {
  var isCheckoutPage = _ref.isCheckoutPage,
      currentLanguageLabel = _ref.currentLanguageLabel,
      onAction = _ref.onAction,
      Link = _ref.Link,
      isLogin = _ref.isLogin,
      intl = _ref.intl,
      user = _ref.user,
      changeLang = _ref.changeLang,
      additionalMenu = _ref.additionalMenu,
      profile = _ref.profile,
      proPlanId = _ref.proPlanId,
      queryPath = _ref.queryPath;
  if (isCheckoutPage) return React.createElement(React.Fragment, null);
  return React.createElement(React.Fragment, null, !isCheckoutPage && React.createElement(Sidebar, {
    Link: Link,
    intl: intl,
    user: user,
    isLogin: isLogin,
    profile: profile,
    onAction: onAction,
    queryPath: queryPath,
    proPlanId: proPlanId,
    changeLang: changeLang,
    isCheckoutPage: isCheckoutPage,
    additionalMenu: additionalMenu,
    currentLanguageLabel: currentLanguageLabel
  }));
};